import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

export const getUserProfileAPI = async () => {
  const token = getAuthToken();

  if (!token) {
    console.error("Authentication token missing.");
    return { data: null, error: "Authentication required" };

    
  }

  try {
    console.log("Fetching user profile data...");
    const response = await axios.get(`${API_ENDPOINTS.profile}`, {
      headers: { Authorization: token },
    });

    console.log("Full API Response:", response);

    // Ensure we're checking for the correct structure
    if (response.status === 200 && response.data?.success && response.data) {
      console.log("Extracted User Data:", response.data);
      return { data: response.data.data, error: null };
    } else {
      console.error("Unexpected Response Structure:", response.data);
      return { data: null, error: "Unexpected response format" };
    }
  } catch (error) {
    console.error("Error fetching user profile data:", error.response?.data || error.message);
    return { data: null, error: "Failed to load user profile" };
  }
};

